import { render, staticRenderFns } from "./kplh.vue?vue&type=template&id=1362ce18&scoped=true&"
import script from "./kplh.vue?vue&type=script&lang=js&"
export * from "./kplh.vue?vue&type=script&lang=js&"
import style0 from "./kplh.vue?vue&type=style&index=0&id=1362ce18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1362ce18",
  null
  
)

export default component.exports